import { Component } from '@theme/component';
import { ThemeEvents, CartUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { sectionRenderer } from '@theme/section-renderer';

/**
 * A custom element that displays and updates the free shipping bar.
 *
 * @extends {Component}
 */
class FreeShippingBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  /**
   * Handles the cart update event.
   * @param {CartUpdateEvent} event - The cart update event.
   */
  #handleCartUpdate = async (event) => {
    const sections = event.detail.data.sections || {};
    
    for (const [sectionId, sectionHtml] of Object.entries(sections)) {
      const newSectionHTML = new DOMParser().parseFromString(
        sectionHtml,
        'text/html'
      );

      const newFreeShippingBar = newSectionHTML.querySelector('free-shipping-bar');
      
      if (newFreeShippingBar) {
        morph(this, newFreeShippingBar, { childrenOnly: true });
        this.dataset.threshold = newFreeShippingBar.dataset.threshold;
        this.dataset.cartTotal = newFreeShippingBar.dataset.cartTotal;
        return;
      }
    }

    const headerSection = document.querySelector('[id^="shopify-section-header"]');
    if (headerSection) {
      const headerSectionId = headerSection.id.replace('shopify-section-', '');
      try {
        const headerHtml = await sectionRenderer.renderSection(headerSectionId, { cache: false });
        const parsedHtml = new DOMParser().parseFromString(headerHtml, 'text/html');
        const newFreeShippingBar = parsedHtml.querySelector('free-shipping-bar');
        
        if (newFreeShippingBar) {
          morph(this, newFreeShippingBar, { childrenOnly: true });
          this.dataset.threshold = newFreeShippingBar.dataset.threshold;
          this.dataset.cartTotal = newFreeShippingBar.dataset.cartTotal;
        } else if (this.parentElement) {
          this.remove();
        }
      } catch (error) {
        console.warn('Failed to update free shipping bar:', error);
      }
    }
  };
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}

